<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-16 22:02:37
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-23 15:02:59
-->
<template>
  <el-main>
    <div class="main">
      <el-form
        ref="filterForm"
        :inline="true"
        :model="filterForm"
        class="filter-form"
      >
        <el-form-item prop="orderNum">
          <el-input
            v-model="filterForm.orderNum"
            placeholder="订单编号"
            style="width: 130px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="hzs">
          <el-input
            v-model="filterForm.hzs"
            placeholder="被委托方"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="orderType">
          <el-select
            v-model="filterForm.orderType"
            placeholder="订单类型"
            style="width: 120px"
          >
            <el-option label="全部" value="0"></el-option>
            <el-option label="全程托管" value="2"></el-option>
            <el-option label="单项服务" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="crop">
          <el-select
            v-model="filterForm.crop"
            placeholder="种植作物"
            style="width: 120px"
          >
            <el-option label="全部" value="0"></el-option>
            <el-option
              v-for="item in cropData"
              :key="item.id"
              :label="item.cropName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="workType">
          <el-select
            v-model="filterForm.workType"
            placeholder="作业类型"
            style="width: 130px"
          >
            <el-option label="全部" value="0"></el-option>
            <el-option
              v-for="item in workTypeData"
              :key="item.id"
              :label="item.workTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="statusFlag">
          <el-select
            v-model="filterForm.statusFlag"
            placeholder="订单状态"
            style="width: 120px"
          >
            <el-option label="全部" value="0"></el-option>
            <el-option
              v-for="item in status"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilterPro('filterForm')"
            >查询</el-button
          >
          <el-button
            type="primary"
            plain
            @click="handleResetFilter('filterForm')"
            ><i class="el-icon-refresh-right"></i>清空</el-button
          >
        </el-form-item>
      </el-form>
      <el-table :data="orders" style="width: 100%">
        <el-table-column label="序号" width="80" align="center" fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="订单编号"
          min-width="130"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderTypeName"
          label="订单类型"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="cropName"
          label="种植作物"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeName"
          label="作业类型"
          min-width="150"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="作业时间要求"
          min-width="290"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="trusteeshipNum"
          label="托管地块"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workFinishNum"
          label="已作业地块"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="noAuditNum"
          label="待审核地块"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditPassNum"
          label="合格"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditFailNum"
          label="不合格"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="200"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleLookDetail(scope.row)"
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
export default {
  name: "FarmingWorkAuditList",
  data() {
    return {
      filterForm: {
        orderNum: "",
        hzs: "",
        orderType: "",
        crop: "",
        workType: "",
        statusFlag: "",
      },
      cropData: [],
      workTypeData: [],
      status: [
        { id: 5, name: "待确认" },
        { id: 10, name: "已确认" },
        { id: 15, name: "执行中" },
        { id: 20, name: "已结束" },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      orders: [],
    };
  },
  filters: {
    formatDate(value) {
      if (!value) return;
      let result = "";
      let ary = value.split("-");
      result = `${ary[0]}年${ary[1]}月${ary[2]}日`;
      return result;
    },
  },
  watch: {
    "filterForm.crop"(newValue) {
      if (newValue != 0) {
        this.filterForm.workType = "";
        this.workTypeData = [];
        this.getCropWork2({ cropId2: newValue });
      }
    },
  },
  mounted() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.getOrderList();
    this.getAllCropList();
    this.getCropWork2();
  },
  methods: {
    /**
     * @descripttion: 获取种植作物下拉框数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:12:00
     */
    getAllCropList() {
      this.$http.common.getAllCropList().then((res) => {
        this.cropData = res.data;
      });
    },
    /**
     * @descripttion: 获取作业类型二级数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:18:11
     */
    getCropWork2(params) {
      this.$http.common.getCropWork2(params).then((res) => {
        this.workTypeData = res.data;
      });
    },
    /**
     * @descripttion: 查询
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:33:18
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getOrderList();
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:34:18
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.pagination.currentPage = 1;
      this.getOrderList();
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:35:18
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm };
      if (this.allFilters.orderType == 0) {
        delete this.allFilters.orderType;
      }
      if (this.allFilters.crop == 0) {
        delete this.allFilters.crop;
      }
      if (this.allFilters.workType == 0) {
        delete this.allFilters.workType;
      }
      if (this.allFilters.statusFlag == 0) {
        delete this.allFilters.statusFlag;
      }
    },
    /**
     * @descripttion: 获取订单列表
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getOrderList() {
      this.getAllFilters();
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, masterId: this.masterId };
      Object.assign(params, params, this.allFilters);
      this.$http.village.getOrderList(params).then((res) => {
        let { recordTotal, content: orders } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.orders = orders;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getOrderList();
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:04:18
     * @param {*} params
     */
    handleLookDetail(params, type) {
      this.$router.push({
        path: "/village/trustee/work-audit/detail",
        query: { id: params.id, from_type: type },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.main {
  .list {
    .item {
      margin-bottom: 20px;
      .top-info {
        display: flex;
        align-items: center;
        color: #018388;
        .cell {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-right: 4%;
          &:first-child {
            flex-wrap: nowrap;
          }
          &:nth-child(4) {
            margin-right: 0;
          }
          &.number {
            font-weight: 900;
          }
        }
        .btn {
          height: 34px;
          line-height: 34px;
          padding: 0 15px;
          margin-left: auto;
        }
      }
      .el-table {
        margin-top: 10px;
      }
    }
  }
}
::v-deep .preview-img {
  position: absolute;
  z-index: -1;
  width: 100px;
  height: 100px;
}
</style>
